/**
 * GESKE UK: Effects (LED spectrum + Smartsonic pulsation)
 * Interaction layer for snippets/led-spectrum.liquid and
 * snippets/smartsonic-pulsation.liquid. Liquid/CSS/JS analogues of .com's
 * WebGL CategoryLedSpectrum + CategorySmartsonicPulsation. Styling lives in
 * assets/geske-effects.css. Every block is scoped to its own root so the same
 * snippet can render multiple times on a page (PDP + category landing).
 */

(function () {
  'use strict';

  /* ===================== LED SPECTRUM ===================== */
  function initLedSpectrum() {
    var blocks = document.querySelectorAll('[data-led-spectrum]');
    if (!blocks.length) return;

    blocks.forEach(function (block) {
      var bands = block.querySelectorAll('[data-led-band]');
      var benefits = block.querySelectorAll('[data-led-benefit]');
      var glow = block.querySelector('[data-led-glow]');
      if (!bands.length) return;

      function setGlow(hex) {
        if (glow && hex) glow.style.setProperty('--led-active', hex);
      }

      function activate(index) {
        bands.forEach(function (band) {
          var match = band.dataset.ledBand === index;
          band.classList.toggle('is-active', match);
          band.setAttribute('aria-selected', match ? 'true' : 'false');
          if (match) setGlow(band.dataset.ledHex);
        });
        benefits.forEach(function (benefit) {
          benefit.classList.toggle('is-active', benefit.dataset.ledBenefit === index);
        });
      }

      bands.forEach(function (band) {
        band.addEventListener('click', function () {
          activate(band.dataset.ledBand);
        });
      });

      // Seed the ambient glow from the first (active) band.
      setGlow(bands[0].dataset.ledHex);
    });
  }

  /* ===================== SMARTSONIC PULSATION ===================== */
  function initSmartsonicPulsation() {
    var blocks = document.querySelectorAll('[data-pulsation]');
    if (!blocks.length) return;

    blocks.forEach(function (block) {
      var levels = parseInt(block.dataset.pulsationLevels, 10) || 5;
      if (levels < 2) levels = 2;

      var minusBtn = block.querySelector('[data-pulsation-minus]');
      var plusBtn = block.querySelector('[data-pulsation-plus]');
      var dots = block.querySelectorAll('[data-pulsation-dot]');
      var stage = block.querySelector('[data-pulsation-rings]');
      var current = 0;

      function render() {
        var ratio = levels > 1 ? current / (levels - 1) : 0;
        if (stage) stage.style.setProperty('--level', ratio.toFixed(3));
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === current);
        });
        if (minusBtn) minusBtn.disabled = current <= 0;
        if (plusBtn) plusBtn.disabled = current >= levels - 1;
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', function () {
          if (current < levels - 1) {
            current += 1;
            render();
          }
        });
      }
      if (minusBtn) {
        minusBtn.addEventListener('click', function () {
          if (current > 0) {
            current -= 1;
            render();
          }
        });
      }

      // Reset to the lowest level when the stage scrolls out of view, so the
      // shopper always re-enters the deep-dive at rest (matches .com).
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting && current !== 0) {
              current = 0;
              render();
            }
          });
        }, { threshold: 0 });
        io.observe(block);
      }

      render();
    });
  }

  /* ===================== BOOTSTRAP ===================== */
  function init() {
    initLedSpectrum();
    initSmartsonicPulsation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
